import { XStack, Theme, SimpleText, useWindowDimensions } from '@my/ui'
import { Link, useNavigate } from 'react-router-dom'
import { UserButton, /* useUser, */ Show } from '@clerk/react'
import { TZAPrivacyPolicy, TZATermsConditions } from 'app/features/termsfeed'
import { ShareFeedbackScreen } from 'app/features/feedback'
import { NotificationIcon } from 'app/components/index'
import { TZALogo, MenuButton } from 'app/components/CustomHeader'
import { TZAApiClient, useAuthedRequestFn, useUser } from '@my/util'
import { CircleX, CreditCard, FileCheck, MessageCircleQuestion, ScrollText, Shield } from '@tamagui/lucide-icons-2'
import { defaultTo } from 'lodash'
import { useState } from 'react'

const DotIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" />
    </svg>
  )
}

export const MyHeader: React.FC<{
  handlePress: () => void
  showIcon?: boolean
  showUserButton?: boolean
}> = ({
  handlePress,
  showIcon,
  showUserButton
}) => {
  const navigate = useNavigate();
  const { width: windowWidth } = useWindowDimensions();
  const isSmallerWindow = windowWidth <= 600;
  const { user, ...restUser } = useUser();
  const authedRequestFn = useAuthedRequestFn();
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const financialProfileQuery = TZAApiClient.useFinancialProfile();
  const fullName = financialProfileQuery?.data?.["Full name"] || user?.fullName || '';
  const showButton = defaultTo(showUserButton, true);
  const openBillingPortal = async () => {
    const result = await authedRequestFn('/user-profile/billing-portal', {query: {
      returnUrl: window.location.href,
    }});
    if (result.portalUrl) {
      window.location = result.portalUrl;
    }
  }
  const openInvestmentAdvisoryAgreement = async () => {
    try {

      // 1. Fetch as a Blob
      const blob = await authedRequestFn('/user-profile/advisory-agreement', { responseType: 'blob' });

      // 2. Create the Blob URL
      const blobUrl = URL.createObjectURL(blob);

      // 3. Open in a new tab
      // We use a link element to bypass some stricter popup blockers
      const link = document.createElement('a');
      link.href = blobUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer'; // Security best practice
      document.body.appendChild(link);
      link.click();

      // 4. Cleanup
      document.body.removeChild(link);
      // Revoke after a delay to ensure the browser has finished loading it
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch (error) {
      console.error('Failed to open PDF:', error);
    }
  };
  return (
    <XStack
      elevationAndroid={5}
      theme={'tza' as any}
      tag="header"
      bg="#fff"
      py="$2"
      px="$3"
      style={{
        boxShadow: 'rgb(133 193 157 / 40%) 0px 2px 8px 0px',
        elevation: 5, // For Android
        zIndex: 500,
        justifyContent:"space-between",
        top: 0,
        position: 'sticky',
      }}
    >
      <Show when="signed-in">
        {/* <MenuButton onClick={handlePress} /> */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            borderWidth: 1,
          }}
        >
          {showIcon && <MenuButton onPress={handlePress} />}
        </div>
      </Show>
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Link onClick={() => {
          window.scrollTo(0,0);
          navigate('/');
        }}>
          <TZALogo small={isSmallerWindow} />
        </Link>
      </div>
      <XStack tag="nav" space="$3" style={{ marginLeft: 'auto', alignItems: 'center' }}>
        {/* <LinkHeader to='https://github.com/johnsimeroth/learn-tamagui'>
            <SizableText>GitHub</SizableText>
          </LinkHeader>
          <Separator alignSelf='stretch' vertical />
          <LinkHeader to='https://tamagui.dev'>
            <SizableText>Tamagui Docs</SizableText>
          </LinkHeader>
          <Separator alignSelf='stretch' vertical />
          <LinkHeader to='https://solito.dev'>
            <SizableText>Solito Docs</SizableText>
          </LinkHeader>
          <Separator alignSelf='stretch' vertical /> */}
        {/* showIcon && <NotificationIcon onPress={() => {}} /> */}
        <ShareFeedbackScreen open={feedbackOpen} setOpen={setFeedbackOpen} />
        {showButton ? <Show when="signed-in">
          <UserButton>
            <UserButton.MenuItems>
              <UserButton.Action label="Billing" labelIcon={<CreditCard height={16} width={16} color={'currentcolor'} />} onClick={openBillingPortal} />
              <UserButton.Action label="Share Questions & Suggestions" labelIcon={<MessageCircleQuestion height={16} width={16} color={'currentcolor'} />} onClick={() => setFeedbackOpen(true)} />
              <UserButton.Action label="Privacy Policy" labelIcon={<Shield height={16} width={16} color={'currentcolor'} />} open="privacy-policy" />
              <UserButton.Action label="Terms & Conditions" labelIcon={<ScrollText height={16} width={16} color={'currentcolor'} />} open="terms-conditions" />
              <UserButton.Action label="Advisory Agreement" labelIcon={<FileCheck height={16} width={16} color={'currentcolor'} />} onClick={openInvestmentAdvisoryAgreement} />
              {restUser?.['isOverrideUser']
                ? <UserButton.Action label="Stop Overriding User" labelIcon={<CircleX height={16} width={16} color={'currentcolor'} />} onClick={restUser?.['logoutOverrideUser']} />
                : null
              }
            </UserButton.MenuItems>

            <UserButton.UserProfilePage label="Privacy Policy" labelIcon={<Shield height={16} width={16} color={'currentcolor'} />} url="privacy-policy">
              <TZAPrivacyPolicy />
            </UserButton.UserProfilePage>
            <UserButton.UserProfilePage label="Terms & Conditions" labelIcon={<ScrollText height={16} width={16} color={'currentcolor'} />} url="terms-conditions">
              <TZATermsConditions />
            </UserButton.UserProfilePage>
          </UserButton>
          {!isSmallerWindow && (
            <SimpleText paddingLeft={5} fontSize={16} fontWeight={'600'} color={'#000'}>
              {fullName}
            </SimpleText>
          )}
        </Show> : null}
      </XStack>
    </XStack>
  )
}
